export function getImgSrc(name: string): string {
  return require(`@/assets/${name}.png`);
}
